module.exports = __webpack_public_path__ + "static/media/1-01.fb7f4d9b.png";